import React from "react";
import classes from './HeaderActionBar.module.css'
import ReactDom from "react-dom";
import SearchBtn from "./Icons/SearchBtn";
import FAQBtn from "./Icons/FAQBtn";
import ShareBtn from "./Icons/ShareBtn";
import SupportBtn from "./Icons/SupportBtn";
import SettingBtn from "./Icons/SettingBtn";
import MessagesBtn from "./Icons/MessagesBtn";
import ToDoBtn from "./Icons/ToDoBtn";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { onKeyDown } from "../../../../service";

const HeaderActionBar = ({ filtercb, filters, hideLogo, hideIcons }) => {

    const texts = useSelector(state => state.translate.texts);
    const { logo, robotImg, homeUrl, showNameInLogo } = useSelector((state) => state.application);
    const { direction } = useSelector((state) => state.translate);
    const { user } = useSelector(state => state.auth);
    const navigate = useNavigate();

    return (
        <>
            {ReactDom.createPortal(
                (<div className={`${classes[direction]} ${classes.HeaderActionContainer}`}>
                    <div className={classes.HeaderActionBarContainer}>
                        <div className={classes.HeaderActionBar}>

                            <div className={classes.LogosContainer}>
                                {/* <div className={`${classes.HomeIcon} ${classes.Logo}`} onClick={() => navigate(`${homeUrl}`)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => navigate(`${homeUrl}`))}></div> */}
                                <div className={`${classes.EduLogo} ${classes.Logo}`}></div>
                                <div className={`${classes.SkillzLogo} ${classes.Logo}`} onClick={() => navigate(`${homeUrl}`)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => navigate(`${homeUrl}`))}></div>
                            </div>
                            <div className={classes.IconsContainer}>
                                {!hideIcons && <div className={classes.IconsAction}>
                                    <SearchBtn filtercb={filtercb} filters={filters}></SearchBtn>
                                    <SettingBtn />
                                    <ToDoBtn />
                                    {/* <ShareBtn /> */}
                                    <SupportBtn />
                                    <FAQBtn />
                                    <MessagesBtn />
                                </div>}
                            </div>
                        </div>
                        {!showNameInLogo ?
                            <img className={classes.RobortIcon} src={robotImg} alt='RobotIcon' />
                            :
                            <div className={classes.LogoWrap}>
                                <img src={robotImg} alt='RobotIcon' />
                                {showNameInLogo && <p className={classes.UserName}>{texts.hello}  <br /> {user.firstName} {user.lastName}</p>}
                            </div>}
                    </div>
                </div>), document.getElementById('portalHeader')
            )}
        </>

    )
}

export default HeaderActionBar;